import { Box, Button } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { focusElemnt } from '../../../utilityFunctions'

const ImageModal = (props) => {
    const { handleImage } = props
    const [file, setFile] = useState(null)
    const [openCamera, setOpenCamera] = useState(false)
    return (
        <>
            {openCamera ?
                <CameraUi captureCallback={(file) => {
                    setFile(file)
                    setOpenCamera(false)
                }} />
                :
                <>
                    <input
                        style={{ display: 'none' }}
                        id="upload-photo-input"
                        name="upload-photo"
                        type="file"
                        accept="image/*,.pdf"
                        onChange={(e) => {
                            setFile(e.target.files[0])
                        }}
                    />
                    {file ? (
                        <div
                            style={{
                                width: '100%',
                                height: '30vh',
                                border: '0.2em dotted #0086ff',
                                marginBottom: '10px',
                            }}
                        >
                            <img
                                style={{
                                    height: '100%',
                                    width: '100%',
                                }}
                                alt=''
                                src={URL.createObjectURL(file)}
                            />
                        </div>
                    ) : ''}
                    <Button
                        variant="outlined"
                        size="medium"
                        className="btn-dotted-outline"
                        onClick={(e) => {
                            document.getElementById('upload-photo-input').click()
                        }}
                    >
                        Upload Image
                    </Button>
                    <Button variant="outlined" size="medium"
                        className={`btn-dotted-outline`}
                        onClick={() => { setOpenCamera(true) }}
                        sx={{ marginY: '10px' }}

                    >
                        Capture Image From Camera
                    </Button>
                    <Button variant="contained" size="medium"
                        className={`btn-orange`}
                        id='searchBtn'
                        onClick={() => {
                            handleImage(file)
                        }}
                    >
                        Save
                    </Button>
                </>
            }
        </>
    )
}

export default ImageModal



const CameraUi = (data) => {
    const { captureCallback } = data
    const videoRef = useRef(null)
    const [imageFile, setImageFile] = useState(null)
    let videoStream = null // Declare a variable to store the video stream
    const handleCameraAccess = () => {
        navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
                const videoElement = videoRef.current
                if (videoElement) {
                    videoElement.srcObject = stream
                    videoElement.play()
                    videoStream = stream
                }
            })
            .catch((error) => {
                console.error('Error accessing camera:', error)
            })
    }
    const stopCameraAccess = () => {
        if (videoStream) {
            const tracks = videoStream.getTracks()
            tracks.forEach((track) => {
                track.stop() // Stop each track in the video stream
            })
            videoStream = null // Clear the video stream variable
        }
    }
    const handleCapture = () => {
        const videoElement = videoRef.current

        if (videoElement && videoElement.srcObject) {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')

            // Set canvas dimensions to match the video element
            canvas.width = videoElement.videoWidth
            canvas.height = videoElement.videoHeight

            // Draw the current video frame onto the canvas
            context.drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight)

            // Convert the canvas content to a data URL
            const dataUrl = canvas.toDataURL('image/jpeg')

            // Convert data URL to Blob
            stopCameraAccess()
            const file = dataURLtoFile(dataUrl, 'image.jpg')
            captureCallback(file)
        }
    }
    const dataURLtoFile = (dataURL, filename) => {
        const arr = dataURL.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
    }
    useEffect(() => {
        setTimeout(() => {
            focusElemnt('camerabuttonOk')
        }, 0)
    })
    useEffect(() => {
        if (videoRef.current) {
            handleCameraAccess()
        }
    }, [videoRef])
    return (
        <>
            <Box>
                {!imageFile && <video ref={videoRef} />}
                {imageFile && <img src={URL.createObjectURL(imageFile)} alt="" />}
            </Box>
            <Box >


                <Button variant="contained" size="medium"
                    className={`btn-orange`}
                    id='searchBtn'
                    onClick={() => handleCapture()}

                >
                    {imageFile ? 'Save Image' : 'Capture Image'}
                </Button>
            </Box>
        </>
    )
}